import { render, staticRenderFns } from "./flightdetails.vue?vue&type=template&id=d2a69950&scoped=true&"
import script from "./flightdetails.vue?vue&type=script&lang=js&"
export * from "./flightdetails.vue?vue&type=script&lang=js&"
import style0 from "./flightdetails.vue?vue&type=style&index=0&id=d2a69950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a69950",
  null
  
)

export default component.exports